import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Appointment } from '../appointment';
import { Patient } from '../../patient/patient';
import { AppointmentService } from '../../service/appointment.service';
import { PatientService } from '../../service/patient.service';

@Component({
  selector: 'mc-appointment-new',
  templateUrl: './appointment-new.component.html',
  styleUrls: ['./appointment-new.component.scss']
})
export class AppointmentNewComponent implements OnInit {

  patient: Patient;

  constructor(
    private appointmentService: AppointmentService,
    private patientService: PatientService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    this.patientService.getPatient(id).subscribe(patient => this.patient = patient);
  }

  onFormCanceled(): void {
    this.router.navigate(['home']);
  }

  onFormSaved(appointment: Appointment): void {
    appointment.patient = this.patient;
    this.appointmentService.createAppointment(appointment).subscribe(
      res => this.router.navigate([`paciente/${this.patient.id}/atendimento`]),
    );
  }

  // TODO: refactor this. it is the same code as in appointment-show.ts
  calculatePatientAge(): number {
    if ((!this.patient) || (!this.patient.dob)) return 0;
    let diff = Math.abs((new Date()).valueOf() - (new Date(this.patient.dob)).valueOf());
    return Math.floor(diff / 31536000000);
  }

}
